import {Injectable} from '@angular/core';
import {NavService} from './nav-service';
import {Router} from '@angular/router';
import {EparcoursPath} from '../../constantes/menu/menu-items/eparcours-path';
import {NavigatorWithParam, PARAM_TOKEN} from './navigators/navigators';
import {PersonnesPath} from '../../pages/personnes/personnes-path';

@Injectable({
  providedIn: 'root',
})
export class PersonnesNavService extends NavService {
  constructor(router: Router) {
    super(router);
  }

  editionGeneral = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PERSONNES,
    PersonnesPath.EDITION,
    PARAM_TOKEN,
    PersonnesPath.EDITION_GENERAL,
  );

  utilisateur = this.makeNavigatorWith2Params<number, string>(
    EparcoursPath.root.PERSONNES,
    EparcoursPath.personnes.EDITION,
    PARAM_TOKEN,
    EparcoursPath.personnes.EDITION_GENERAL,
    EparcoursPath.personnes.EDITION_UTILISATEUR,
    PARAM_TOKEN,
  );

  editionInscriptions = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PERSONNES,
    PersonnesPath.EDITION,
    PARAM_TOKEN,
    PersonnesPath.LISTE_INSCRIPTIONS,
  );

  factureByIdPersonne = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PERSONNES,
    PersonnesPath.EDITION,
    PARAM_TOKEN,
    PersonnesPath.LISTE_FACTURES,
  );

  documentsByIdPersonne = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PERSONNES,
    PersonnesPath.EDITION,
    PARAM_TOKEN,
    PersonnesPath.DOCUMENTS,
  );

  taches = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PERSONNES,
    PersonnesPath.EDITION,
    PARAM_TOKEN,
    PersonnesPath.TACHES
  )

  contrats = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PERSONNES,
    PersonnesPath.EDITION,
    PARAM_TOKEN,
    PersonnesPath.CONTRATS,
  );

  creation = this.makeNavigator(EparcoursPath.root.PERSONNES, PersonnesPath.CREATION);

  liste = this.makeNavigator(EparcoursPath.root.PERSONNES);

  creation_inscription: NavigatorWithParam<number> = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.PERSONNES,
    PersonnesPath.EDITION,
    PARAM_TOKEN,
    PersonnesPath.CREATION_INSCRIPTION
  )
}
